<template>
    <pm-app-component hide-sidebar />
</template>

<script>
import SettingsService from "../../extensions/services/settings-service";
import getSettings from "../../configs/settings";
import getProtocols from "../../configs/protocols";
import {
    exchangeProtocolPrices,
    exchangeTreatmentPrices,
    translateProtocolTitles,
    translateTreatmentTitles,
} from "@/extensions/services/pricelist-service";

const packageResolverList = new Map([
    [null, "/plan"],
    ["com.denticalc.calculationtool", "/plan"],
    ["com.denticalc.calculator", "/calculator"],
    ["com.denticalc.photos", "/gallery"],
    ["com.denticalc.pro", "/plan"],
    ["com.denticalc.videos", "/animations"],
    ["com.denticalc.4in1", "/"],
]);

export default {
    async activated() {
        await this.useDemo();
        await this.$router.push(packageResolverList.get(window.packageName)).catch((err) => null);
    },
    async mounted() {
        await this.useDemo();
        await this.$router.push(packageResolverList.get(window.packageName)).catch((err) => null);
    },
    data: () => {
        return ({
            country: "US",
            language: app.$store.state.language,
            currency: app.$store.state.currency,
            dentalNotation: app.$store.state.dentalNotation || "ISO",
            autoDetectSettings: true,
        });
    },
    watch: {
        country() {
            // if (["US"].includes(this.country)) this.dentalNotation = "USA";
            // else this.dentalNotation = "ISO";
        },
    },
    methods: {
        useDemo() {
            try {
                let notation = "ISO";
                let country = "US";
                let currency = "USD";
                /** @type {string} */
                const language = SettingsService.getDefaultLanguage();

                if (this.autoDetectSettings) {
                    country = SettingsService.getDefaultCountry();
                    this.$store.state.localSettings.country = country;

                    notation = SettingsService.getDefaultNotation();
                    currency = SettingsService.getDefaultCurrency();

                    translateProtocolTitles(language);
                    translateTreatmentTitles(language);
                    exchangeProtocolPrices(currency);
                    exchangeTreatmentPrices(currency);
                }

                const {settings: localSettings} = getSettings(country, language, currency);
                const {protocols} = getProtocols(country, language, currency);

                this.$store.state.localSettings = localSettings;
                this.$store.state.dentalStates = localSettings.dentalStates;
                this.$store.state.localSettings.protocols = protocols;

                this.country = country;
                this.dentalNotation = notation;
                this.language = language;

                if (["IN"].includes(this.country)) this.language = "en";

                this.currency = currency;

                this.save();
            } catch(error) {
                captureException(error);
                this.fallbackToDefaults();
                this.save();
            }
        },

        fallbackToDefaults() {
            const {settings: localSettings} = getSettings("US", "en", "USD");
            const {protocols} = getProtocols("US", "en", "USD");
            this.$store.state.localSettings = localSettings;
            this.$store.state.dentalStates = localSettings.dentalStates;
            this.$store.state.localSettings.protocols = protocols;
        },

        save() {
            // Set the language
            window.i18n.locale = this.language;
            this.$store.state.localSettings.language = this.language;
            this.$store.state.language = this.language;
            // Set the currency
            this.$store.state.currency = this.currency;
            this.$store.state.localSettings.currency = this.currency;
            // Set the notation
            this.$store.state.dentalNotation = this.dentalNotation;
            this.$store.state.localSettings.dentalNotation = this.dentalNotation;
            // Set the country
            this.$store.state.localSettings.country = this.country;
            // Store data
            localStorage.setItem("settings", JSON.stringify(this.$store.state.localSettings));
        },
    },
};
</script>
